import { CLabel } from "@coreui/react";
import React from "react";
import Auth from "src/auth";

const LotListViewFooter = (props) => {
  const { authenticated } = Auth();
  return (
    <>
      {/*
          //&&
            // EmdPaid.isEMDPaid == true &&
            //  props.viewTenderDetails &&
            // authenticated.role === "Bidder" &&
            //  props.viewTenderDetails?.isSanctionLetterGenerated &&
            //  props.viewListDetails.isSanctionAccepted === 1 &&
            //  props.viewTenderDetails?.isAgreementLetterGenerated &&
            //  props.viewListDetails.isAgreementAccepted === 1 &&
            //  props.viewTransferDetails.length === 0  */}
      <div className="pl-1 pr-1 mt-3">
        {authenticated.role === "Bidder" &&
        props.viewListDetails.lotTransferCount < 2 &&
        props.viewListDetails.status !== "Terminated" &&
        props.viewTenderDetails?.isSanctionLetterGenerated &&
        props.viewListDetails.isSanctionAccepted === 1 &&
        props.viewTenderDetails?.isAgreementLetterGenerated &&
        props.viewListDetails.isAgreementAccepted === 1 &&
        props.viewListDetails.isCCFSignedAgreement === true &&
        props.viewTransferDetails &&
        (props.viewTransferDetails.length === 0 ||
          props.viewTransferDetails[props.viewTransferDetails.length - 1]
            .status === 2) ? (
          <>
            <CLabel>
              <strong>Lot Transfer Last Date: </strong>
            </CLabel>
            <CLabel
              style={{
                fontStyle: "italic",
              }}
            >
              {props.viewListDetails.bidderAllowToTransferLotLastDate}
            </CLabel>
            <br></br>
          </>
        ) : (
          ""
        )}
        {props.viewListDetails ? (
          props.viewListDetails?.bidderLastDateOfAgreement !== null &&
          props.viewListDetails?.bidderLastDateOfAgreement !== "" &&
          (props.viewListDetails.islottransferd === 0 ||
            props.viewListDetails.lotTransferCount < 2) ? (
            <>
              <CLabel>
                <strong>Note: Last date of agreement signed : </strong>
              </CLabel>
              <CLabel
                style={{
                  fontStyle: "italic",
                }}
              >
                {props.viewListDetails.bidderLastDateOfAgreement}
              </CLabel>
            </>
          ) : (
            ""
          )
        ) : (
          ""
        )}
        <br></br>
        <CLabel
          style={{
            fontStyle: "italic",
            color: "red",
          }}
        >
          <strong>Note: </strong> If you have completed payment transaction via
          Payment Gateway and it is not showing (success/failure) then please
          wait for 15 minutes to retry the payment transaction.
        </CLabel>

        {props.viewListDetails &&
        props.EmdPaid.isEMDPaid === true &&
        props.viewTenderDetails &&
        authenticated.role === "CFO" &&
        props.viewTenderDetails?.isSanctionLetterGenerated &&
        props.viewListDetails.isSanctionAccepted === 1 &&
        props.viewTenderDetails?.isAgreementLetterGenerated &&
        props.viewListDetails.isAgreementAccepted === 1 &&
        (props.viewTransferDetails.length === 0 ||
          props.viewListDetails.lotTransferCount < 2) ? (
          props.viewListDetails?.cfoLastDateOfAgreement !== null &&
          props.viewListDetails?.cfoLastDateOfAgreement !== "" ? (
            <>
              <br></br>
              <CLabel>
                <strong>CFO Note: </strong>
              </CLabel>
              <CLabel
                style={{
                  fontStyle: "italic",
                }}
              >
                {props.viewListDetails?.cfoLastDateOfAgreement}
              </CLabel>
            </>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default LotListViewFooter;
